import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLegalSeparationIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.3966 6.37383C11.59 6.16908 11.9141 6.16491 12.1133 6.36406L15.3966 9.64629C15.7115 9.96122 15.4883 10.4996 15.043 10.4998H14.0001V13.4998C14.0001 13.7759 13.7761 13.9997 13.5001 13.9998H13.0001C12.7239 13.9998 12.5001 13.7759 12.5001 13.4998V12.7498C12.5 12.3357 12.1641 11.9999 11.7501 11.9998C11.3359 11.9998 11.0002 12.3357 11.0001 12.7498V13.4998C11.0001 13.7759 10.7761 13.9997 10.5001 13.9998H10.0001C9.72393 13.9998 9.50007 13.7759 9.50007 13.4998V10.4998H8.66022C8.2218 10.4998 7.99536 9.97593 8.29597 9.65703L11.3966 6.37383Z",
		stroke: "none",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.89655 2.37383C4.08999 2.16908 4.41415 2.16491 4.61335 2.36406L7.89655 5.64629C8.21146 5.96122 7.98833 6.49962 7.54304 6.4998H6.50007V9.4998C6.50007 9.77589 6.27614 9.99972 6.00007 9.9998H5.50007C5.22393 9.9998 5.00007 9.77595 5.00007 9.4998V8.7498C4.99996 8.33573 4.66415 7.99989 4.25007 7.9998C3.83592 7.9998 3.50017 8.33568 3.50007 8.7498V9.4998C3.50007 9.77589 3.27614 9.99972 3.00007 9.9998H2.50007C2.22393 9.9998 2.00007 9.77595 2.00007 9.4998V6.4998H1.16023C0.721803 6.4998 0.495361 5.97593 0.795968 5.65703L3.89655 2.37383Z",
		stroke: "none",
		fill: "currentColor"
	})]
});
export default SvgLegalSeparationIcon;
